/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@/styles/settings.scss";

// import { createApp } from "vue";
import { createVuetify } from "vuetify";
import { VDateInput } from "vuetify/labs/VDateInput";

//import CompassIcon from '@/components/icon/Compass.vue';
//import CompassNavigatorIcon from '@/components/icon/CompassNavigator.vue';
// import { aliases, mdi } from "vuetify/iconsets/mdi";

/*const aliasesCustom = {
  CompassIcon: CompassIcon,
  CompassNavigatorIcon: CompassNavigatorIcon,
};*/

export default createVuetify({
  components: {
    VDateInput,
  },
  theme: {
    defaultTheme: "system",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#00507d",
          "on-primary": "#FFFFFF",
          secondary: "#EFFAFF",
          "on-secondary": "#00507d",
          action: "#091F2F",
          brand: "#00507d",
          "on-brand": "#FFFFFF",
          background: "#F3F4F6",
          "on-background": "#222222",
          surface: "#FFFFFF",
          "shop-panel": "#E9EDF2",

          "on-surface": "#222222",
          soft: "#999999",
          info: "#2da4e0ff",
          "on-info": "#FFFFFF",
          success: "#558B2F",
          "on-success": "#FFFFFF",
          warning: "#F57C00",
          "on-warning": "#FFFFFF",
          error: "#F70303",
          "on-error": "#FFFFFF",
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: "#38a3e0",
          "on-primary": "#FFFFFF",
          "primary-subtle": "#00507d",
          secondary: "#BDBDBD",
          "on-secondary": "#FFFFFF",
          brand: "#00507d",
          "on-brand": "#FFFFFF",
          background: "#181A1F",
          "on-background": "#A6B8CB",
          background_dark: "#080E14",
          surface: "#223142",
          "shop-panel": "#292D34",
          "on-surface": "#9BB0C3",
          "surface-bright": "#364657",
          scrollbar: "#364657",
          scrollbar_hover: "#45586A",
          default: "#ffffff",
          info: "#48baf4ff",
          "on-info": "#FFFFFF",
          success: "#4aaa79",
          "on-success": "#FFFFFF",
          warning: "#FCD976",
          "on-warning": "#000",
          error: "#E3544C",
          "on-error": "#FFFFFF",
        },
      },
    },
  },
  defaults: {
    global: {
      density: "default",
      elevation: "0",
    },
    VAppBar: {
      color: "secondary",
    },
    VToolbar: {
      color: "transparent",
    },
    VIcon: {},
    VCard: {
      elevation: "4",
      rounded: "lg",
    },
    VCardActions: {
      VBtn: {
        variant: "tonal",
      },
    },
    VSwitch: {
      inset: true,
      color: "primary",
    },
    VNavigationDrawer: {
      color: "surface",
      expandOnHover: true,
    },
    VTextField: {
      variant: "solo-filled",
      density: "comfortable",
    },
    VTextarea: {
      variant: "solo-filled",
      density: "comfortable",
    },
    VDateInput: {
      variant: "solo-filled",
      density: "comfortable",
    },
    VSelect: {
      variant: "solo-filled",
      density: "comfortable",
    },
    VAutocomplete: {
      variant: "solo-filled",
      density: "comfortable",
    },
    VCombobox: {
      variant: "solo-filled",
      density: "comfortable",
    },
    VNumberInput: {
      variant: "solo-filled",
      density: "comfortable",
    },
  },
  /*display: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 0,
      sm: 340,
      md: 540,
      lg: 800,
      xl: 1280,
    },
  },*/
});
